(function () {
  'use strict';

  function initFooter(root) {
    if (!root || root.dataset.bstFooterBound === 'true') return;

    var details = Array.prototype.slice.call(root.querySelectorAll('[data-bst-footer-details]'));
    if (!details.length) return;

    var desktop = window.matchMedia('(min-width: 768px)');
    var sectionId = root.dataset.bstFooterSection;

    function syncDisclosureState() {
      details.forEach(function (detail) {
        if (desktop.matches) detail.setAttribute('open', '');
        else detail.removeAttribute('open');
      });
    }

    function destroy(event) {
      if (event && event.detail && event.detail.sectionId !== sectionId) return;
      if (desktop.removeEventListener) desktop.removeEventListener('change', syncDisclosureState);
      else desktop.removeListener(syncDisclosureState);
      document.removeEventListener('shopify:section:unload', destroy);
      root.dataset.bstFooterBound = 'false';
    }

    syncDisclosureState();
    if (desktop.addEventListener) desktop.addEventListener('change', syncDisclosureState);
    else desktop.addListener(syncDisclosureState);
    document.addEventListener('shopify:section:unload', destroy);
    root.dataset.bstFooterBound = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-bst-footer]').forEach(initFooter);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
